import React, { FC } from "react";
import { Input } from "@/components/basic/Input";
import { usePreviousPageDetect } from "@/hooks/usePreviousPageDetect";

export const PreviousPageInput: FC = () => {
  const { previousPage } = usePreviousPageDetect();

  return <Input name="previousPage" type="hidden" value={previousPage} />;
};
